<template>
  <div>
    <video ref="videoPlayer" controls></video>
  </div>
</template>

<script>
import Hls from 'hls.js';

export default {
  props: {
    streamUrl: String,
  },
  mounted() {
    this.initHls();
  },
  methods: {
    initHls() {
      const video = this.$refs.videoPlayer;
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(this.streamUrl);
        hls.attachMedia(video);
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.streamUrl;
      }
    },
  },
};
</script>
